export const availableEmoji = {
    thumbs_up: '👍',
    sparkling_heart: '💖',
    party_popper: '🎉',
    grinning_squinting_face: '😆',
    face_with_open_mouth: '😮',
}

export type EmojiName = keyof typeof availableEmoji

export const emojiOrder: Record<EmojiName, number> = {
    thumbs_up: 1,
    party_popper: 2,
    sparkling_heart: 3,
    face_with_open_mouth: 4,
    grinning_squinting_face: 5,
}
